import { useApp } from "../context/AppContext";
import { colors } from "../data/config";

export default function Notification() {
  const { notification } = useApp();
  if (!notification) return null;
  return (
    <div style={{
      position: "fixed", top: 20, left: "50%", transform: "translateX(-50%)",
      zIndex: 9999,
      background: notification.type === "error" ? colors.danger : colors.success,
      color: "#fff", padding: "12px 24px", borderRadius: 12,
      fontSize: 14, fontWeight: 600, boxShadow: "0 4px 20px rgba(0,0,0,0.2)"
    }}>
      {notification.msg}
    </div>
  );
}
